class mediaPipePose {
  constructor() {
    this.pose1 = {};
	
	if ( window["electron"] ) {
		if (!window.posemedia || window.posemedia === undefined) {
		  window.posemedia = require("@mediapipe/pose");
		}

		this.pose1 = new window.posemedia.Pose({
		  locateFile: (file) => {
			return (window["applicationPath"] ? window["applicationPath"] + "/build/" : "") + "pose/" + file;
		  },
		});

		this.pose1.setOptions({
		  modelComplexity: 1,
		  smoothLandmarks: true,
		  minDetectionConfidence: 0.8,
		  minTrackingConfidence: 0.8,
		  enableSegmentation: true,
		  smoothSegmentation: true,
		});

		this.pose1.onResults((res) => {
		  this.poseResults(res, this);
		});

		this.pose1.initialize();
		
		window.closePoseAll = this.stopPose;
		window.closePoseAllReload = this.stopPoseReload;
		window.stopPoseReload = this.stopPoseReload;
		window.thisPoseEL = this.pose1;
		
	} else if ( window.loadScriptPost && window.Pose ) {
		this.pose1 = new window.Pose({
				locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`
			  });

		this.pose1.setOptions({
		  modelComplexity: 1,
		  smoothLandmarks: true,
		  minDetectionConfidence: 0.8,
		  minTrackingConfidence: 0.8
		});

		this.pose1.onResults((res) => {
		  this.poseResults(res, this);
		});

		this.pose1.initialize();
		
		window.closePoseAll = this.stopPose;
		window.closePoseAllReload = this.stopPoseReload;
		window.stopPoseReload = this.stopPoseReload;
		window.thisPoseEL = this.pose1;
	} else {
		window.loadScriptPost = true;
		const script = document.createElement('script');
		script.src = 'https://cdn.jsdelivr.net/npm/@mediapipe/pose/pose.js';
		script.onload = () => {
			  // Initialize Pose here after script loads
			this.pose1 = new window.Pose({
				locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`
			  });

			this.pose1.setOptions({
			  modelComplexity: 1,
			  smoothLandmarks: true,
			  minDetectionConfidence: 0.8,
			  minTrackingConfidence: 0.8
			});

			this.pose1.onResults((res) => {
			  this.poseResults(res, this);
			});

			this.pose1.initialize();
			
			window.closePoseAll = this.stopPose;
			window.closePoseAllReload = this.stopPoseReload;
			window.thisPoseEL = this.pose1;
		};

		document.head.appendChild(script);
	}

    this.pendingResult = false;
  }

  getPose(videoElement, callback) {
    if (this.pendingResult) {
      return false;
    }
	

    this.pendingResult = true;
    this.callback = callback;
    this.pose1.send({ image: videoElement });
  }

  poseResults(pose1, mainthis) {
    mainthis.pendingResult = false;
    if (pose1 && pose1.poseLandmarks) {
      if (pose1.segmentationMask) {
        window["poseSegmentationMask"] = pose1.segmentationMask;
      }

      pose1.poseLandmarks.forEach(function (item) {
        item["x"] = 1 - item["x"];
      });

      if (mainthis.callback) {
		window["lastLandmarks"] = pose1.poseLandmarks;
        mainthis.callback(pose1.poseLandmarks, pose1.poseWorldLandmarks);
      }
    } else {
      if (mainthis.callback) {
        mainthis.callback(null, null);
      }
    }
  }
  
  stopPose() {
		window.thisPoseEL.onResults(() => {});
		if (window.thisPoseEL && window.thisPoseEL.close) { window.thisPoseEL.close(); }
	}
  
  stopPoseReload() {
		window.thisPoseEL.onResults(() => {});
		if (window.thisPoseEL && window.thisPoseEL.close) {
			window.thisPoseEL.close();
			window.updateNewMP();
		}
	}
}

export default mediaPipePose;
